import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { StalledCopy } from '../../functions/load-error.functions';
import { IconComponent } from '../icon/icon.component';

/**
 * Shown by `ProgressSpinnerOverlayComponent` when a blocking save outruns its budget. Its only action
 * releases the page; the write itself keeps running, so there is deliberately no retry.
 */
@Component({
  selector: 'app-save-stalled-dialog',
  imports: [MatButtonModule, MatDialogModule, IconComponent],
  templateUrl: './save-stalled-dialog.component.html',
  styleUrl: './save-stalled-dialog.component.scss',
})
export class SaveStalledDialogComponent {
  readonly copy = inject<StalledCopy>(MAT_DIALOG_DATA);
}
